/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async favorite(_, data) {
      return await api.post(`/api/article/favorite`, data);
    },
    async favoriteList(_, data) {
      return await api.post(`/api/user/getFavoriteListByModel`, data);
    },
  },
}
